export const APP_ROUTES = {
  // Authentication
  LOGIN: "/login",
  LOGOUT: "/logout",
  FORGET_PASSWORD: "/forgot-password",
  FORGET_VERIFY_CODE: "/forget-verify-code/:tokenId",
  RESET_PASSWORD: "/reset-password/:tokenId",
  REGISTER: "/register",
  EDIT_PROFILE: "/edit-profile",
  CHANGE_PASSWORD: "/change-password",
  // Dashboard
  BLS_FEEDBACK: "/bls-feedback",
  FEEDBACK_FORMS: "/feedback-forms",
  ADD_FEEDBACK_FORM: "/feedback-forms/add",
  EDIT_FEEDBACK_FORM: "/feedback-forms/edit",
  CUSTOMER_MANAGEMENT: "/customer-management",
  CUSTOMER_DETAILS: "/customer-management/customer-details",
  NOTIFICATION_MANAGEMENT: "/notification-management",
  NOTIFICATION_DETAILS: "/notification-management/view-notification",
  EDIT_NOTIFICATION: "/notification-management/edit-notification",
  ADD_NOTIFICATION: "/notification-management/add-notification",
  CONTENT_LIBRARY: "/content-library",
  CONTENT_LIBRARY_DETAILS: "/content-library/view",
  ADD_CONTENT_LIBRARY: "/content-library/add",
  EDIT_CONTENT_LIBRARY: "/content-library/edit",
  LOCKED_SESSION_CONTENT: "/content-library/locked-sessions",
  EDIT_LOCKED_SESSION: "/content-library/locked-sessions/edit",
  EDIT_RESET_ACTIVITY: "/content-library/locked-sessions/reset",

  // Click Analytics
  CLICK_ANALYTICS: "/click-analytics",
  CLICK_ANALYTICS_DETAILS: "/click-analytics/details",

  // User Analytics
  USER_ANALYTICS: "/user-analytics",

  // Who can open the standalone MCAP dashboard (its own app now — see
  // Config.js MCAP_APP_URL). Not the dashboard itself.
  ADMIN_ACCESS: "/admin-access",

  // People asking to administer a school on the school admin portal. Approving
  // one is what lets them buy a plan and invite their teachers.
  SCHOOL_ADMIN_REQUESTS: "/school-admin-requests",
  DISTRICT_HUB: "/district-hub",
  // Place an existing account under a school and move its classrooms with it (staff only).
  ALIGN_USERS: "/align-users",

  // What each plan costs and how many teachers it covers.
  LICENSE_PLANS: "/license-plans",
  LICENSE_PAYMENTS: "/payments",

  // Which dates/times show as open on the public Book a Demo page, and where
  // new-booking notifications go. Backed by Neo-backend's
  // /admin/demo-availability API — see DemoAvailability's own file comment.
  DEMO_AVAILABILITY: "/demo-availability",
};

export const getParamsAttachedRoute = (route, obj = {}) => {
  let keys = Object.keys(obj);

  if (keys?.length) {
    let objectKeys = keys;

    objectKeys.forEach(() => {
      route = route?.replace(new RegExp(/:([\d\w?])+/, "i"), (match) => {
        let formattedMatchedValue =
          match[match.length - 1] === "?"
            ? match.slice(1, match.length - 1)
            : match.slice(1);
        return obj[formattedMatchedValue];
      });
    });
    return route;
  }
  return route;
};
